import { Link } from 'react-router-dom';

import { CopyToClipboardButton } from '@/components/shared/components/CopyToClipboardButton';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { IconButton } from '@/components/shared/components/IconButton';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface PaymentIntentLinkProps {
  paymentMethodId: string;
  paymentMethodUrl: string;
}

export const PaymentIntentLink = ({ paymentMethodId, paymentMethodUrl }: PaymentIntentLinkProps) => {
  const { palette } = useCustomTheme();

  return (
    <FlexRow color={palette.text.secondary} gridGap={16} width={'100%'}>
      <FlexRow justifyContent="flex-start" gridGap={8} minWidth={0}>
        <Link to={paymentMethodUrl} style={{ flexShrink: 0, display: 'flex' }}>
          <IconButton
            icon="open_in_new"
            iconProps={{ size: 16 }}
            style={{ padding: 0, height: 16, width: 16, color: palette.text.secondary }}
          />
        </Link>
        <Font variant="body2" color="textSecondary" className="overflow-text-ellipsis">
          <Text tId={'LENDER_REQUEST_ID'} />: {paymentMethodId}
        </Font>
      </FlexRow>
      <FlexRow gridGap={8}>
        <CopyToClipboardButton style={{ color: palette.text.secondary }} value={paymentMethodId.toString()} />
      </FlexRow>
    </FlexRow>
  );
};
